var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.1667 40V37C77.1667 35 75.8334 33.6667 73.8334 33.6667C71.8334 33.6667 70.5 35 70.5 37V40C70.5 56.6667 57.1667 70 40.5 70C23.8334 70 10.5 56.6667 10.5 40C10.5 23.3333 23.8334 10 40.5 10C44.8334 10 48.8334 11 52.8334 12.6667C54.5 13.3333 56.5 12.6667 57.1667 11C57.8334 9.33334 57.1667 7.33334 55.5 6.66668C50.8334 4.33334 45.5 3.33334 40.5 3.33334C20.1667 3.33334 3.83337 19.6667 3.83337 40C3.83337 60.3333 20.1667 76.6667 40.5 76.6667C60.8334 76.6667 77.1667 60.3333 77.1667 40ZM74.8334 7.66668C76.1667 6.33334 78.1667 6.33334 79.5 7.66668C80.8334 9.00001 80.8334 11 79.5 12.3333L42.8334 49C42.1667 49.6667 41.1667 50 40.5 50C39.8334 50 38.8334 49.6667 38.1667 49L28.1667 39C26.8334 37.6667 26.8334 35.6667 28.1667 34.3333C29.5 33 31.5 33 32.8334 34.3333L40.5 42L74.8334 7.66668Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_208_42100",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 78,
    height: 74
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.1667 40V37C77.1667 35 75.8334 33.6667 73.8334 33.6667C71.8334 33.6667 70.5 35 70.5 37V40C70.5 56.6667 57.1667 70 40.5 70C23.8334 70 10.5 56.6667 10.5 40C10.5 23.3333 23.8334 10 40.5 10C44.8334 10 48.8334 11 52.8334 12.6667C54.5 13.3333 56.5 12.6667 57.1667 11C57.8334 9.33334 57.1667 7.33334 55.5 6.66668C50.8334 4.33334 45.5 3.33334 40.5 3.33334C20.1667 3.33334 3.83337 19.6667 3.83337 40C3.83337 60.3333 20.1667 76.6667 40.5 76.6667C60.8334 76.6667 77.1667 60.3333 77.1667 40ZM74.8334 7.66668C76.1667 6.33334 78.1667 6.33334 79.5 7.66668C80.8334 9.00001 80.8334 11 79.5 12.3333L42.8334 49C42.1667 49.6667 41.1667 50 40.5 50C39.8334 50 38.8334 49.6667 38.1667 49L28.1667 39C26.8334 37.6667 26.8334 35.6667 28.1667 34.3333C29.5 33 31.5 33 32.8334 34.3333L40.5 42L74.8334 7.66668Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_208_42100)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 80,
    height: 80,
    fill: "#59B245"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.d9ede25a92f053f84f1b9b329c0f1954.svg";
export { ForwardRef as ReactComponent };